import { render } from "./CookieBanner.vue?vue&type=template&id=4894d6e0&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=4894d6e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4894d6e0"
/* hot reload */
if (module.hot) {
  script.__hmrId = "4894d6e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4894d6e0', script)) {
    api.reload('4894d6e0', script)
  }
  
  module.hot.accept("./CookieBanner.vue?vue&type=template&id=4894d6e0&scoped=true", () => {
    api.rerender('4894d6e0', render)
  })

}

script.__file = "src/components/CookieBanner.vue"

export default script